export const LOGIN_USER_STARTED = 'LOGIN_USER_STARTED';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';

export const AUTHORIZE_USER_STARTED = 'AUTHORIZE_USER_STARTED';
export const AUTHORIZE_USER_SUCCESS = 'AUTHORIZE_USER_SUCCESS';
export const AUTHORIZE_USER_FAILED = 'AUTHORIZE_USER_FAILED';

export const SET_GRAPHAPI_CONFIG = 'SET_GRAPHAPI_CONFIG';

export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
